// @flow strict

type Props = {|
  text: string,
  max: number,
|};

/**
 * Abbreviates text, maintaining words if possible
 *
 * @param {string} text - The text to abbreviate
 * @param {number} max - The maximum length to return
 */
const Abbreviate = ({ text, max }: Props) => {
  if (text.length < max) {
    // No need to truncate
    return text;
  }
  const maxWithEllipsis = max - 3;
  const idealBreak = text.lastIndexOf(' ', maxWithEllipsis);
  if (idealBreak < 0) {
    // No spaces, so just truncate
    return `${text.substring(0, maxWithEllipsis)}...`;
  }

  // Truncate at the last word break before the max length
  return `${text.substring(0, idealBreak)}...`;
};

export default Abbreviate;
